<div class="osk-container">
  <div class="osk-display">
    <span class="osk-value" *ngIf="value">{{ displayValue }}</span>
    <span class="osk-placeholder" *ngIf="!value">{{ placeholder }}</span>
    <span class="osk-cursor">|</span>
  </div>

  <div class="osk-keys">
    <div class="osk-row" *ngFor="let row of rows" [class.osk-row-rut]="mode === 'rut'">
      <button
        *ngFor="let key of row"
        class="osk-key"
        [class.osk-key-backspace]="key === '⌫'"
        (click)="pressKey(key)">
        {{ key }}
      </button>
    </div>

    <!-- Bottom row for text mode -->
    <div class="osk-row osk-row-bottom" *ngIf="mode === 'text'">
      <button class="osk-key osk-key-backspace" (click)="backspace()">⌫</button>
      <button class="osk-key osk-key-space" (click)="pressSpace()">ESPACIO</button>
      <button class="osk-key osk-key-enter" (click)="pressEnter()">OK</button>
    </div>

    <!-- Enter for rut mode -->
    <div class="osk-row osk-row-bottom" *ngIf="mode === 'rut'">
      <button class="osk-key osk-key-enter osk-key-wide" (click)="pressEnter()">OK</button>
    </div>
  </div>
</div>
